export default [0, '1px solid', '2px solid', '4px solid', '8px solid'];